/**
 * API функции для авторизации и восстановления пароля
 */

import { http } from './http'

export interface PasswordResetTokenValidationResponse {
  success: boolean
  message: string
  error_type?: string
  user?: {
    contact_id: number
    email: string
    name: string
    first_name: string
    last_name: string
  }
}

/**
 * Валидация токена восстановления пароля
 */
export async function validatePasswordResetToken(token: string): Promise<PasswordResetTokenValidationResponse> {
  try {
    const response = await http.post('/web_auth/validate-reset-token', {
      token
    })
    return response.data
  } catch (error: any) {
    // Если сервер вернул структурированную ошибку
    if (error.response?.data) {
      return error.response.data
    }
    
    // Fallback для неожиданных ошибок
    return {
      success: false,
      message: 'Произошла ошибка при проверке токена',
      error_type: 'network_error'
    }
  }
}

/**
 * Запрос восстановления пароля
 */
export async function requestPasswordReset(email: string) {
  const response = await http.post('/web_auth/request-password-reset', {
    email: email.trim().toLowerCase()
  })
  return response.data
}

/**
 * Сброс пароля по токену
 */
export async function resetPassword(token: string, newPassword: string) {
  const response = await http.post('/web_auth/reset-password', {
    token,
    new_password: newPassword
  })
  return response.data
}
